export default [
  {
    description:
      'PUAN berkisah tentang perempuan Indonesia, pergulatan keseharian, keringat, air mata, tawa, & kecintaannya, bersama @mardiyahchamim, penulis dan pejalan.',
    title: 'Sekilas Mengenai Puan Indonesia',
    media: ['https://i.imgur.com/fWCgwbX.mp4']
  }
]
